// extracted by mini-css-extract-plugin
export var photosTab = "styles-module__photosTab___ky6Vn";
export var addPhotoSquare = "styles-module__addPhotoSquare___joekT";
export var addIcon = "styles-module__addIcon___cSLXb";
export var uploadedPhoto = "styles-module__uploadedPhoto___GGxFg";
export var uploadedImg = "styles-module__uploadedImg___aZEU_";
export var emptyPhotoContainer = "styles-module__emptyPhotoContainer___qt3Lt";